var _rect, _rect2, _g, _rect3, _rect4, _rect5, _rect6, _g2, _path, _g3, _path2, _g4, _circle, _circle2, _g5, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMsteamsNode(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 118,
    height: 95,
    viewBox: "0 0 118 95",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_ddd_937_17090)"
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 9,
    y: 6,
    width: 100,
    height: 24,
    rx: 4,
    fill: "white",
    fillOpacity: 0.12,
    shapeRendering: "crispEdges"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 15,
    y: 12,
    width: 12,
    height: 12,
    rx: 2,
    fill: "#FC8F37"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_937_17090)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.5 17.2486C20.5 17.3149 20.4737 17.3785 20.4268 17.4254C20.3799 17.4723 20.3163 17.4986 20.25 17.4986H20V18.7486C20 18.8149 19.9737 18.8785 19.9268 18.9254C19.8799 18.9723 19.8163 18.9986 19.75 18.9986C19.6837 18.9986 19.6201 18.9723 19.5732 18.9254C19.5263 18.8785 19.5 18.8149 19.5 18.7486V17.4986H19.25C19.1837 17.4986 19.1201 17.4723 19.0732 17.4254C19.0263 17.3785 19 17.3149 19 17.2486C19 17.1823 19.0263 17.1187 19.0732 17.0718C19.1201 17.025 19.1837 16.9986 19.25 16.9986H20.25C20.3163 16.9986 20.3799 17.025 20.4268 17.0718C20.4737 17.1187 20.5 17.1823 20.5 17.2486ZM24.25 16.8967V18.7486C24.2499 19.0619 24.1323 19.3637 23.9203 19.5943C23.7083 19.8249 23.4174 19.9675 23.1053 19.9939C22.9566 20.3638 22.7007 20.6809 22.3705 20.9043C22.0403 21.1277 21.6509 21.2474 21.2522 21.2479C20.8535 21.2484 20.4638 21.1297 20.133 20.9071C19.8023 20.6845 19.5456 20.3681 19.3959 19.9986H18.25C18.1174 19.9986 17.9902 19.9459 17.8964 19.8522C17.8027 19.7584 17.75 19.6312 17.75 19.4986V16.4986C17.75 16.366 17.8027 16.2388 17.8964 16.1451C17.9902 16.0513 18.1174 15.9986 18.25 15.9986H20.0253C19.9669 15.7106 20.0117 15.4113 20.1521 15.1531C20.2924 14.8949 20.5192 14.6944 20.7926 14.5868C21.066 14.4792 21.3686 14.4714 21.6473 14.5647C21.9259 14.658 22.1628 14.8465 22.3162 15.0971C22.5089 15.0045 22.726 14.9761 22.936 15.0159C23.1459 15.0558 23.3376 15.1619 23.4829 15.3186C23.6281 15.4753 23.7194 15.6745 23.7432 15.8868C23.767 16.0992 23.7222 16.3136 23.6153 16.4986H23.8519C23.9574 16.4988 24.0586 16.5408 24.1332 16.6154C24.2078 16.69 24.2498 16.7912 24.25 16.8967ZM20.5 15.7486C20.5 15.8338 20.5146 15.9184 20.5431 15.9986H21.25C21.3534 15.9987 21.4542 16.0309 21.5385 16.0907C21.6228 16.1504 21.6866 16.2349 21.7209 16.3324C21.8196 16.2528 21.8964 16.1495 21.9443 16.0322C21.9922 15.9149 22.0096 15.7874 21.9949 15.6615C21.9802 15.5357 21.9338 15.4156 21.8601 15.3125C21.7864 15.2094 21.6878 15.1267 21.5735 15.072C21.4592 15.0174 21.3329 14.9926 21.2064 14.9999C21.0799 15.0073 20.9573 15.0466 20.8501 15.1142C20.7429 15.1817 20.6546 15.2754 20.5933 15.3863C20.5321 15.4973 20.5 15.6219 20.5 15.7486ZM21.25 19.4986V16.4986H18.25V19.4986H21.25ZM22.75 16.9986H21.75V19.4986C21.75 19.6312 21.6973 19.7584 21.6036 19.8522C21.5098 19.9459 21.3826 19.9986 21.25 19.9986H19.9513C20.1164 20.2844 20.3713 20.5078 20.6763 20.6341C20.9813 20.7603 21.3194 20.7824 21.6383 20.697C21.9571 20.6116 22.2389 20.4233 22.4399 20.1614C22.6409 19.8996 22.7499 19.5787 22.75 19.2486V16.9986ZM23.25 15.9986C23.2499 15.9097 23.2261 15.8223 23.181 15.7457C23.1359 15.669 23.0711 15.6057 22.9934 15.5624C22.9157 15.5191 22.8279 15.4973 22.7389 15.4993C22.65 15.5013 22.5632 15.5269 22.4875 15.5736C22.5107 15.7358 22.5016 15.901 22.4608 16.0598C22.4201 16.2185 22.3484 16.3676 22.25 16.4986H22.75C22.8826 16.4986 23.0098 16.4459 23.1036 16.3522C23.1973 16.2584 23.25 16.1312 23.25 15.9986ZM23.75 16.9986H23.25V19.2486C23.25 19.3191 23.2463 19.3895 23.2387 19.4596C23.3877 19.4095 23.5172 19.314 23.6089 19.1865C23.7006 19.0589 23.75 18.9057 23.75 18.7486V16.9986Z",
    fill: "#FFF4F0"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    },
    opacity: 0.4
  }, _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 33,
    y: 16,
    width: 70,
    height: 4,
    rx: 1,
    fill: "white"
  })))), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_ddd_937_17090)"
  }, _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 9,
    y: 66,
    width: 100,
    height: 24,
    rx: 4,
    fill: "white",
    fillOpacity: 0.12,
    shapeRendering: "crispEdges"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    },
    opacity: 0.9
  }, _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 15,
    y: 72,
    width: 12,
    height: 12,
    rx: 2,
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    },
    opacity: 0.4
  }, _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 33,
    y: 76,
    width: 70,
    height: 4,
    rx: 1,
    fill: "white"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_f_937_17090)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M58.7348 66.2652C58.8813 66.4116 59.1187 66.4116 59.2652 66.2652L61.6517 63.8787C61.7981 63.7322 61.7981 63.4948 61.6517 63.3483C61.5052 63.2019 61.2678 63.2019 61.1213 63.3483L59 65.4697L56.8787 63.3483C56.7322 63.2019 56.4948 63.2019 56.3484 63.3483C56.2019 63.4948 56.2019 63.7322 56.3484 63.8787L58.7348 66.2652ZM58.625 55L58.625 56.375L59.375 56.375L59.375 55L58.625 55ZM58.625 57.2917L58.625 60.0417L59.375 60.0417L59.375 57.2917L58.625 57.2917ZM58.625 60.9583L58.625 63.7083L59.375 63.7083L59.375 60.9583L58.625 60.9583ZM58.625 64.625L58.625 66L59.375 66L59.375 64.625L58.625 64.625Z",
    fill: "#7DB9FF"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M58.7348 66.2652C58.8813 66.4116 59.1187 66.4116 59.2652 66.2652L61.6517 63.8787C61.7981 63.7322 61.7981 63.4948 61.6517 63.3483C61.5052 63.2019 61.2678 63.2019 61.1213 63.3483L59 65.4697L56.8787 63.3483C56.7322 63.2019 56.4948 63.2019 56.3484 63.3483C56.2019 63.4948 56.2019 63.7322 56.3484 63.8787L58.7348 66.2652ZM58.625 55L58.625 57.2917L59.375 57.2917L59.375 55L58.625 55ZM58.625 58.2083L58.625 62.7917L59.375 62.7917L59.375 58.2083L58.625 58.2083ZM58.625 63.7083L58.625 66L59.375 66L59.375 63.7083L58.625 63.7083Z",
    fill: "#42CFEF"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter3_f_937_17090)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M59 30L59 38",
    stroke: "#7DB9FF",
    strokeWidth: 0.75,
    strokeDasharray: "3 1"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M59 30L59 38",
    stroke: "#42CFEF",
    strokeWidth: 0.75,
    strokeDasharray: "5 1"
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter4_f_937_17090)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 58.751,
    cy: 46.75,
    r: 8.25,
    stroke: "#7DB9FF",
    strokeWidth: 0.75,
    strokeMiterlimit: 3.99933,
    strokeDasharray: "3 1"
  }))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 58.751,
    cy: 46.75,
    r: 8.25,
    stroke: "#42CFEF",
    strokeWidth: 0.5,
    strokeMiterlimit: 3.99933,
    strokeDasharray: "3 1"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 58.75,
    cy: 46.75,
    r: 6.75,
    fill: "white"
  })), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_937_17090)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M59.6669 45.1997C59.9196 45.1529 60.1539 45.0355 60.3426 44.8611C60.5314 44.6867 60.6669 44.4625 60.7335 44.2143C60.8002 43.9661 60.7952 43.7041 60.7192 43.4586C60.6432 43.2132 60.4993 42.9942 60.304 42.8271C60.1088 42.66 59.8703 42.5516 59.616 42.5144C59.3617 42.4771 59.1021 42.5127 58.8672 42.6168C58.6323 42.7209 58.4316 42.8895 58.2884 43.1029C58.1453 43.3163 58.0654 43.5658 58.0582 43.8227H58.7208C59.2434 43.8227 59.6669 44.2463 59.6669 44.7688V45.1997ZM57.251 49.5523H58.7208C59.2434 49.5523 59.6669 49.1288 59.6669 48.6062V45.6401H61.2324C61.3366 45.6428 61.4355 45.6867 61.5074 45.7622C61.5794 45.8377 61.6184 45.9387 61.616 46.0429V48.4583C61.6305 49.0837 61.3962 49.6893 60.9645 50.1421C60.5328 50.5948 59.9391 50.8578 59.3137 50.8731C58.4035 50.8506 57.6262 50.3162 57.251 49.5512V49.5523ZM63.2905 44.2806C63.2905 44.4043 63.2662 44.5268 63.2188 44.641C63.1715 44.7553 63.1021 44.8591 63.0147 44.9466C62.9272 45.0341 62.8234 45.1035 62.7091 45.1508C62.5948 45.1981 62.4723 45.2225 62.3486 45.2225C62.2249 45.2225 62.1025 45.1981 61.9882 45.1508C61.8739 45.1035 61.7701 45.0341 61.6826 44.9466C61.5951 44.8591 61.5258 44.7553 61.4784 44.641C61.4311 44.5268 61.4067 44.4043 61.4067 44.2806C61.4067 44.0308 61.506 43.7912 61.6826 43.6146C61.8592 43.4379 62.0988 43.3387 62.3486 43.3387C62.5984 43.3387 62.838 43.4379 63.0147 43.6146C63.1913 43.7912 63.2905 44.0308 63.2905 44.2806ZM62.0317 49.6176L61.9642 49.6165C62.1142 49.247 62.1872 48.8508 62.1785 48.4521V46.0485C62.1807 45.908 62.1518 45.7688 62.0941 45.6407H63.1021C63.3215 45.6407 63.4998 45.819 63.4998 46.0384V48.1562C63.4995 48.5437 63.3454 48.9152 63.0714 49.1892C62.7974 49.4632 62.4259 49.6173 62.0384 49.6176H62.0317Z",
    fill: "#394353"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.8836 44.3873H58.721C58.9331 44.3873 59.1046 44.5588 59.1046 44.7709V48.6083C59.1048 48.6587 59.095 48.7087 59.0757 48.7553C59.0565 48.8019 59.0282 48.8442 58.9926 48.8799C58.9569 48.9155 58.9146 48.9438 58.868 48.963C58.8214 48.9822 58.7714 48.9921 58.721 48.9919H54.8836C54.8332 48.9921 54.7833 48.9822 54.7366 48.963C54.69 48.9438 54.6477 48.9155 54.612 48.8799C54.5764 48.8442 54.5481 48.8019 54.5289 48.7553C54.5097 48.7087 54.4999 48.6587 54.5 48.6083V44.7703C54.5 44.5583 54.6716 44.3873 54.8836 44.3873ZM57.812 45.8475V45.4425H55.7926V45.8475H56.5559V47.9372H57.0453V45.8475H57.812Z",
    fill: "#394353"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_ddd_937_17090",
    x: 0,
    y: 0,
    width: 118,
    height: 42,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 1,
    operator: "dilate",
    in: "SourceAlpha",
    result: "effect1_dropShadow_937_17090"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0588235 0 0 0 0 0.0901961 0 0 0 0 0.164706 0 0 0 0.12 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_937_17090"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.117647 0 0 0 0 0.160784 0 0 0 0 0.231373 0 0 0 0.12 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_dropShadow_937_17090",
    result: "effect2_dropShadow_937_17090"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 3
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.117647 0 0 0 0 0.160784 0 0 0 0 0.231373 0 0 0 0.06 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect2_dropShadow_937_17090",
    result: "effect3_dropShadow_937_17090"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect3_dropShadow_937_17090",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_ddd_937_17090",
    x: 0,
    y: 60,
    width: 118,
    height: 42,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 1,
    operator: "dilate",
    in: "SourceAlpha",
    result: "effect1_dropShadow_937_17090"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0588235 0 0 0 0 0.0901961 0 0 0 0 0.164706 0 0 0 0.12 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_937_17090"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.117647 0 0 0 0 0.160784 0 0 0 0 0.231373 0 0 0 0.12 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_dropShadow_937_17090",
    result: "effect2_dropShadow_937_17090"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 3
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.117647 0 0 0 0 0.160784 0 0 0 0 0.231373 0 0 0 0.06 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect2_dropShadow_937_17090",
    result: "effect3_dropShadow_937_17090"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect3_dropShadow_937_17090",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_f_937_17090",
    x: 48.2383,
    y: 47,
    width: 21.5234,
    height: 27.375,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4,
    result: "effect1_foregroundBlur_937_17090"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_f_937_17090",
    x: 50.625,
    y: 22,
    width: 16.75,
    height: 24,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4,
    result: "effect1_foregroundBlur_937_17090"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter4_f_937_17090",
    x: 47.126,
    y: 35.125,
    width: 23.25,
    height: 23.25,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.5,
    result: "effect1_foregroundBlur_937_17090"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_937_17090"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 8,
    height: 8,
    fill: "white",
    transform: "translate(17 14)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_937_17090"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 9,
    height: 9,
    fill: "white",
    transform: "translate(54.5 42.5)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMsteamsNode);
export default __webpack_public_path__ + "static/media/msteamsNode.074c55329beee914e5bcbf39b0ab9cf0.svg";
export { ForwardRef as ReactComponent };